import { useEffect, useMemo, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../app/components/ui/select";
import { api } from "../../lib/api";
import { useAuth } from "../../providers/AuthProvider";

export type DealerOption = { id: string; name: string; status: string | null };

export function DealerSelector({
  value,
  onValueChange,
  disabled,
  placeholder = "Select dealer",
}: {
  value: string;
  onValueChange: (next: string) => void;
  disabled?: boolean;
  placeholder?: string;
}) {
  const { token } = useAuth();
  const [rows, setRows] = useState<DealerOption[]>([]);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      const res = await api.dealers.list({ token });
      if (!cancelled) {
        setRows(res.data.map((d) => ({ id: d.id, name: d.name, status: d.status })));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const sorted = useMemo(() => [...rows].sort((a, b) => a.name.localeCompare(b.name)), [rows]);

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {sorted.map((d) => (
          <SelectItem key={d.id} value={String(d.id)}>
            {d.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

